import { BsBoxSeam, BsArchive } from "react-icons/bs";
import { CgChart, CgFeed, CgGirl, CgUserList } from "react-icons/cg";
import { FaWpforms } from "react-icons/fa";
import { MdHome, MdOutlinePriceChange, MdShoppingCart } from "react-icons/md";
import { RiPlantLine } from "react-icons/ri";

const NavConfig = [
  {
    title: "Dashboard",
    permissions: ["Stock View", "Tech", "Admin"],
    path: "/app/dashboard",
    icon: MdHome
  },
  {
    title: "Lotes",
    permissions: ["Reception", "Stock View", "Tech", "Admin"],
    icon: BsBoxSeam,
    children: [
      {
        title: "Recebimento",
        permissions: ["Reception", "Tech", "Admin"],
        path: "/app/recebimento"
      },
      {
        title: "Confirmar lotes",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/confirm-batch"
      },
      {
        title: "Conferência de recebimento",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/conferencia-de-recebimento"
      },
      {
        title: "Seleção",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/selecao"
      },
      {
        title: "Confirmação de seleção",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/confirmacao-de-selecao"
      },
      {
        title: "Lotes",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/lotes"
      },
      {
        title: "Reembolso/Reposição",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/batch-return"
      },
      {
        title: "Alinhamento com o seller",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/alinhamento-com-o-seller"
      },
      {
        title: "Devolução Física",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/devolucao-fisica"
      },
      {
        title: "Contagem",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/batch-count"
      }
    ]
  },
  {
    title: "Estoque",
    permissions: ["Stock View", "Tech", "Admin"],
    icon: CgChart,
    children: [
      {
        title: "Extrato",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/estoque-extrato"
      },
      {
        title: "Resumo",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/estoque-resumo"
      },
      {
        title: "Resumo SKU",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/estoque-resumo-sku"
      },
      {
        title: "Físico",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/estoque-fisico"
      },
      {
        title: "Bloqueados",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/estoque-bloqueado"
      },
      {
        title: "Cancelamentos",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/estoque-cancelamentos"
      },
      {
        title: "Histórico",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/historico-estoque"
      }
    ]
  },
  {
    title: "Fornecedores",
    permissions: ["Stock View", "Tech", "Admin"],
    icon: CgGirl,
    children: [
      {
        title: "Fornecedores",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/fornecedores",
        icon: CgGirl
      },
      {
        title: "Certificados",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/fornecedores/certificados",
        icon: CgGirl
      },
      {
        title: "Ranking",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/fornecedores/ranking",
        icon: CgGirl
      },
      {
        title: "Pedidos",
        permissions: ["Previsão", "Tech"],
        path: "/app/fornecedores/pedidos",
        icon: CgGirl
      }
    ]
  },
  {
    title: "Produto p/ fornecedor",
    permissions: ["Stock View", "Tech", "Admin"],
    path: "/app/produto-por-fornecedor",
    icon: CgFeed
  },
  {
    title: "Produtos",
    permissions: ["Stock View", "Tech", "Admin"],
    icon: RiPlantLine,
    children: [
      {
        title: "Produtos base",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/produtos"
      },
      {
        title: "Skus",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/skus"
      },
      {
        title: "Categorias",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/produtos/categorias"
      },
      {
        title: "Subcategorias",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/produtos/subcategorias"
      },
      {
        title: "Tipos de estoque",
        permissions: ["Stock View", "Tech", "Admin"],
        path: "/app/produtos/estocagem"
      }
    ]
  },
  {
    title: "Compras e Abastecimento",
    permissions: ["Previsão", "Tech", "Admin"],
    icon: MdShoppingCart,
    children: [
      {
        title: "Previsão",
        permissions: ["Previsão", "Tech", "Admin"],
        path: "/app/compras-abastecimento/previsao-de-compra"
      },
      {
        title: "Requisição",
        permissions: ["Previsão", "Tech", "Admin"],
        path: "/app/compras-abastecimento/requisicao-de-compra"
      },
      {
        title: "Configurações",
        permissions: ["Previsão", "Tech", "Admin"],
        path: "/app/compras-abastecimento/configuracoes"
      }
    ]
  },
  {
    title: "Controle de Ativos",
    permissions: ["Stock View", "Estoque", "Tech"],
    icon: BsArchive,
    children: [
      {
        title: "Ativos",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/ativos"
      },
      {
        title: "Transações",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/ativos-transacoes"
      },
      {
        title: "Extrato",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/ativos-extrato"
      },
      {
        title: "Resumo",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/ativos-resumo"
      },
      {
        title: "Contagem diária",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/ativos-contagem-diaria"
      },
      {
        title: "Saldo por fornecedor",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/ativos-saldo-fornecedor"
      }
    ]
  },
  {
    title: "Regras",
    permissions: ["Stock View", "Tech"],
    icon: FaWpforms,
    children: [
      {
        title: "Blitz",
        path: "/app/regra-da-blitz"
      },
      {
        title: "Estoque",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/regras-de-estoque"
      },
      {
        title: "Shelf life",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/regras-shelf-life"
      },
      {
        title: "Margem",
        permissions: ["Stock View", "Estoque", "Tech", "Admin"],
        path: "/app/regras-margens-estoque"
      },
      {
        title: "Migração",
        path: "/app/regra-de-migracao"
      }
    ]
  },
  {
    title: "Grupos de Seleção",
    permissions: ["Stock View", "Tech", "Admin"],
    path: "/app/grupos-selecao",
    icon: CgUserList
  },
  {
    title: "Precificação",
    permissions: ["Precificação", "Tech", "Admin"],
    icon: MdOutlinePriceChange,
    children: [
      {
        title: "Precificação",
        permissions: ["Precificação", "Tech", "Admin"],
        path: "/app/precificacao"
      },
      {
        title: "Sugestões de Promoção",
        permissions: ["Precificação", "Tech", "Admin"],
        path: "/app/precificacao/sugestoes-promo"
      }
    ]
  }
];

export default NavConfig;
